// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ForgotPasswordStyle.css */

/* Уникальные классы для страницы восстановления пароля */
.fp-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.fp-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 440px;
}

.fp-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.fp-back-button {
  background: none;
  border: none;
  color: #002FA7;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  margin-bottom: 16px;
  transition: color 0.3s ease;
  font-family: 'Montserrat', sans-serif;
  width: 32px;
  height: 32px;
}

.fp-back-button:hover {
  color: #5986f7;
}

.fp-card-header {
  text-align: right;
  margin-bottom: 32px;
}

.fp-headline {
  color: #002FA7;
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 8px 0;
  font-family: 'Montserrat', sans-serif;
  text-align: center;
}

.fp-desc {
  color: #64748b;
  font-size: 14px;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
  text-align: center;
}

.fp-input-group {
  margin-bottom: 24px;
}

.fp-input-field {
  position: relative;
}

.fp-email-input {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 16px;
  color: #1e293b;
  background: white;
  transition: all 0.3s ease;
  box-sizing: border-box;
  font-family: 'Montserrat', sans-serif;
}

.fp-email-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
}

.fp-email-input:disabled {
  background: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
}

.fp-code-group {
  margin-bottom: 24px;
  text-align: center;
}

.fp-code-inputs {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 16px;
}

.fp-code-input {
  width: 50px;
  height: 60px;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  color: #002FA7;
  background: white;
  transition: all 0.3s ease;
  font-family: 'Montserrat', sans-serif;
}

.fp-code-input:focus {
  outline: none;
  border-color: #002FA7;
  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);
  transform: translateY(-2px);
}

.fp-code-input:disabled {
  background: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
}

.fp-code-hint {
  color: #64748b;
  font-size: 14px;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
}

.fp-code-actions {
  text-align: center;
  margin-bottom: 24px;
}

.fp-resend-button {
  background: none;
  border: none;
  color: #002FA7;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
  font-family: 'Montserrat', sans-serif;
}

.fp-resend-button:hover:not(:disabled) {
  background: #f1f5f9;
  color: #5986f7;
}

.fp-resend-button:disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.fp-submit-button {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 24px;
  font-family: 'Montserrat', sans-serif;
}

.fp-submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.3);
}

.fp-submit-button:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.fp-success-content {
  text-align: center;
  padding: 20px 0;
}

.fp-success-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  color: white;
  margin: 0 auto 24px;
  animation: fp-successAppear 0.6s ease-out;
}

@keyframes fp-successAppear {
  from {
    opacity: 0;
    transform: scale(0.5) rotate(-180deg);
  }
  to {
    opacity: 1;
    transform: scale(1) rotate(0);
  }
}

.fp-success-message {
  color: #64748b;
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
}

.fp-error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
}

.fp-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e2e8f0;
}

.fp-support-text {
  color: #718096;
  font-size: 13px;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
  text-align: center;
}

.fp-support-link {
  color: #3c5ceb;
  text-decoration: none;
  font-weight: 400;
  transition: color 0.3s ease;
  font-family: 'Montserrat', sans-serif;
}

.fp-support-link:hover {
  color: #5986f7;
}

/* Уникальные стили для анимации фона */
.fp-background-animation {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.fp-background-animation .fp-shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.03);
  animation: float 6s ease-in-out infinite;
}

.fp-shape-1 {
  width: 300px;
  height: 300px;
  top: -150px;
  left: -150px;
  animation-delay: 0s;
}

.fp-shape-2 {
  width: 200px;
  height: 200px;
  bottom: -100px;
  right: -100px;
  animation-delay: 2s;
}

.fp-shape-3 {
  width: 150px;
  height: 150px;
  top: 50%;
  left: 70%;
  animation-delay: 4s;
}

@keyframes fp-float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

/* Уникальные стили для заголовка */
.fp-login-header {
  text-align: center;
  margin-bottom: 40px;
}

.fp-login-title {
  color: white;
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  font-family: 'Montserrat', sans-serif;
}

.fp-login-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
}

.fp-version-info {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  margin-top: 30px;
  font-family: 'Montserrat', sans-serif;
}

/* Адаптивность */
@media (max-width: 480px) {
  .fp-container {
    padding: 16px;
  }
  
  .fp-card {
    padding: 30px 24px;
  }
  
  .fp-headline {
    font-size: 24px;
  }
  
  .fp-desc {
    font-size: 14px;
  }
  
  .fp-code-inputs {
    gap: 8px;
  }
  
  .fp-code-input {
    width: 44px;
    height: 54px;
    font-size: 20px;
  }
  
  .fp-login-title {
    font-size: 28px;
  }
}







.fp-success-alert {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  color: #155724;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
}

.fp-change-email-link {
  background: none;
  border: none;
  color: #002FA7;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  margin-left: 8px;
  transition: color 0.3s ease;
}

.fp-change-email-link:hover {
  color: #5986f7;
}

.fp-email-change-form {
  background: #f8f9ff;
  border-radius: 12px;
  margin-top: 15px;
}

.fp-cancel-button {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  font-family: 'Montserrat', sans-serif;
  color: #64748b;
}

.fp-cancel-button:hover:not(:disabled) {
  background: #e2e8f0;
  border-color: #cbd5e1;
}

.fp-cancel-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Адаптивность для формы смены email */
@media (max-width: 480px) {
  .fp-email-change-form {
    padding: 12px;
  }
  
  .fp-email-change-form div {
    flex-direction: column;
  }
  
  .fp-email-change-form button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPasswordStyle.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAG5B,yDAAyD;AACzD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;EAC7D,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE;IACE,UAAU;IACV,qCAAqC;EACvC;EACA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,2CAA2C,EAAE;AACrD;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;;;;;;AAQA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* ForgotPasswordStyle.css */\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n\n/* Уникальные классы для страницы восстановления пароля */\n.fp-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  padding: 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.fp-content {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 440px;\n}\n\n.fp-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 24px;\n  padding: 40px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.fp-back-button {\n  background: none;\n  border: none;\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  margin-bottom: 16px;\n  transition: color 0.3s ease;\n  font-family: 'Montserrat', sans-serif;\n  width: 32px;\n  height: 32px;\n}\n\n.fp-back-button:hover {\n  color: #5986f7;\n}\n\n.fp-card-header {\n  text-align: right;\n  margin-bottom: 32px;\n}\n\n.fp-headline {\n  color: #002FA7;\n  font-size: 26px;\n  font-weight: 600;\n  margin: 0 0 8px 0;\n  font-family: 'Montserrat', sans-serif;\n  text-align: center;\n}\n\n.fp-desc {\n  color: #64748b;\n  font-size: 14px;\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n  text-align: center;\n}\n\n.fp-input-group {\n  margin-bottom: 24px;\n}\n\n.fp-input-field {\n  position: relative;\n}\n\n.fp-email-input {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 16px;\n  color: #1e293b;\n  background: white;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-email-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n}\n\n.fp-email-input:disabled {\n  background: #f8fafc;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.fp-code-group {\n  margin-bottom: 24px;\n  text-align: center;\n}\n\n.fp-code-inputs {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n\n.fp-code-input {\n  width: 50px;\n  height: 60px;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 24px;\n  font-weight: 600;\n  text-align: center;\n  color: #002FA7;\n  background: white;\n  transition: all 0.3s ease;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-code-input:focus {\n  outline: none;\n  border-color: #002FA7;\n  box-shadow: 0 0 0 3px rgba(0, 47, 167, 0.1);\n  transform: translateY(-2px);\n}\n\n.fp-code-input:disabled {\n  background: #f8fafc;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.fp-code-hint {\n  color: #64748b;\n  font-size: 14px;\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-code-actions {\n  text-align: center;\n  margin-bottom: 24px;\n}\n\n.fp-resend-button {\n  background: none;\n  border: none;\n  color: #002FA7;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 8px 16px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-resend-button:hover:not(:disabled) {\n  background: #f1f5f9;\n  color: #5986f7;\n}\n\n.fp-resend-button:disabled {\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.fp-submit-button {\n  width: 100%;\n  padding: 16px;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  border: none;\n  border-radius: 12px;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 24px;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0, 47, 167, 0.3);\n}\n\n.fp-submit-button:disabled {\n  background: #cbd5e1;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.fp-success-content {\n  text-align: center;\n  padding: 20px 0;\n}\n\n.fp-success-icon {\n  width: 80px;\n  height: 80px;\n  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 36px;\n  color: white;\n  margin: 0 auto 24px;\n  animation: fp-successAppear 0.6s ease-out;\n}\n\n@keyframes fp-successAppear {\n  from {\n    opacity: 0;\n    transform: scale(0.5) rotate(-180deg);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) rotate(0);\n  }\n}\n\n.fp-success-message {\n  color: #64748b;\n  font-size: 16px;\n  line-height: 1.6;\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-error-message {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #dc2626;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  text-align: center;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-footer {\n  text-align: center;\n  padding-top: 20px;\n  border-top: 1px solid #e2e8f0;\n}\n\n.fp-support-text {\n  color: #718096;\n  font-size: 13px;\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n  text-align: center;\n}\n\n.fp-support-link {\n  color: #3c5ceb;\n  text-decoration: none;\n  font-weight: 400;\n  transition: color 0.3s ease;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-support-link:hover {\n  color: #5986f7;\n}\n\n/* Уникальные стили для анимации фона */\n.fp-background-animation {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.fp-background-animation .fp-shape {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.03);\n  animation: float 6s ease-in-out infinite;\n}\n\n.fp-shape-1 {\n  width: 300px;\n  height: 300px;\n  top: -150px;\n  left: -150px;\n  animation-delay: 0s;\n}\n\n.fp-shape-2 {\n  width: 200px;\n  height: 200px;\n  bottom: -100px;\n  right: -100px;\n  animation-delay: 2s;\n}\n\n.fp-shape-3 {\n  width: 150px;\n  height: 150px;\n  top: 50%;\n  left: 70%;\n  animation-delay: 4s;\n}\n\n@keyframes fp-float {\n  0%, 100% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-20px) rotate(180deg); }\n}\n\n/* Уникальные стили для заголовка */\n.fp-login-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.fp-login-title {\n  color: white;\n  font-size: 28px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-login-subtitle {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 14px;\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-version-info {\n  text-align: center;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  margin-top: 30px;\n  font-family: 'Montserrat', sans-serif;\n}\n\n/* Адаптивность */\n@media (max-width: 480px) {\n  .fp-container {\n    padding: 16px;\n  }\n  \n  .fp-card {\n    padding: 30px 24px;\n  }\n  \n  .fp-headline {\n    font-size: 24px;\n  }\n  \n  .fp-desc {\n    font-size: 14px;\n  }\n  \n  .fp-code-inputs {\n    gap: 8px;\n  }\n  \n  .fp-code-input {\n    width: 44px;\n    height: 54px;\n    font-size: 20px;\n  }\n  \n  .fp-login-title {\n    font-size: 28px;\n  }\n}\n\n\n\n\n\n\n\n.fp-success-alert {\n  background: #d4edda;\n  border: 1px solid #c3e6cb;\n  color: #155724;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n  text-align: center;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fp-change-email-link {\n  background: none;\n  border: none;\n  color: #002FA7;\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: underline;\n  padding: 0;\n  margin-left: 8px;\n  transition: color 0.3s ease;\n}\n\n.fp-change-email-link:hover {\n  color: #5986f7;\n}\n\n.fp-email-change-form {\n  background: #f8f9ff;\n  border-radius: 12px;\n  margin-top: 15px;\n}\n\n.fp-cancel-button {\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  font-family: 'Montserrat', sans-serif;\n  color: #64748b;\n}\n\n.fp-cancel-button:hover:not(:disabled) {\n  background: #e2e8f0;\n  border-color: #cbd5e1;\n}\n\n.fp-cancel-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Адаптивность для формы смены email */\n@media (max-width: 480px) {\n  .fp-email-change-form {\n    padding: 12px;\n  }\n  \n  .fp-email-change-form div {\n    flex-direction: column;\n  }\n  \n  .fp-email-change-form button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
